import 'rxjs/add/operator/map';
import { Injectable } from '@angular/core';
import { EncryptDecrypt } from '../../../shared/common/storage-setting/encryptdecrypt';

@Injectable({
    providedIn: 'root'
})

export class StorageConfiguration {

    constructor(private encryptDecrypt: EncryptDecrypt) { }

    public token = 'token';
    public id = 'id';
    public name = 'name';
    public role = 'role';
    public currentlogin = 'currentlogin';
    public email = 'email';
    public password = 'password';
    public user_Info = 'user_Info';
    public updatemessage = 'updatemessage';
    public User_name = 'User_name';
    public isloggedIn = 'isloggedIn';
    public startDate = 'startDate';
    public endDate = 'endDate';
    public profileId = 'profileId';
    public sessiontoken = 'sessiontoken';
    public tenantId = 'tenantId';
    public industryId = 'industryId';
    public projectId = 'projectId';

    public userAuth = 'userAuth'; // User-Password
    public userTimeSheetAutoSave = 'userTimeSheetAutoSave';
    public autoSaveUpdatedTime_userTimeSheet = 'autoSaveUpdatedTime';

    sessionSetItem(key, value) {
        localStorage.setItem(this.encryptDecrypt.encrypt(key), this.encryptDecrypt.encrypt(value));
    }

    sessionGetItem(key) {
        let decryptedValue = localStorage.getItem(this.encryptDecrypt.encrypt(key));
        return decryptedValue != null ? this.encryptDecrypt.decrypt(decryptedValue) : null;
    }

    sessionRemoveItem(key) {
        localStorage.removeItem(this.encryptDecrypt.encrypt(key));
    }


}
